import { render } from "./login.vue?vue&type=template&id=896b24ba&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=896b24ba&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896b24ba"]])

export default __exports__